export const LocationPreviewMap = ({
  apiKey,
  latitude,
  longitude,
}) => {
  const mapQuery = encodeURIComponent(`${latitude},${longitude}`);
  const mapKey = encodeURIComponent(apiKey || "");

  return (
    <div
      className="h-[210px] w-full"
      aria-label="Map showing the selected delivery location"
      data-testid="selected-location-map"
      role="region"
    >
      <iframe
        title="Google Maps preview"
        width="100%"
        height="210"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        className="block h-full w-full"
        data-testid="google-location-map"
        src={
          `https://www.google.com/maps/embed/v1/place?key=${mapKey}`
          + `&q=${mapQuery}&zoom=16`
        }
      />
    </div>
  );
};

export default LocationPreviewMap;